import { Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

import { focusTarget } from './chefStyles';

type FocusedHeadingProps = { children: ReactNode; noWrap?: boolean };

// A screen's h1, which takes focus when it appears so the keyboard carries on from the screen it replaced.
const FocusedHeading = ({ children, noWrap }: FocusedHeadingProps) => {
  const heading = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    heading.current?.focus();
  }, []);

  return (
    <Typography
      ref={heading}
      component="h1"
      noWrap={noWrap}
      tabIndex={-1}
      sx={{ fontSize: { xs: 24, md: 28 }, lineHeight: { xs: '32px', md: '36px' }, fontWeight: 700, ...focusTarget }}
    >
      {children}
    </Typography>
  );
};

export default FocusedHeading;
